function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenericDark = function SvgGenericDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 40,
    height: 26,
    rx: 4,
    ry: 4,
    style: {
      fill: "#8b9c8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.941 17.621c0-.053.014-.106.042-.151l.461-.768a.293.293 0 0 1 .252-.143h2.088c.162 0 .294.132.294.294v4.118a.294.294 0 0 1-.294.294H3.696a.293.293 0 0 1-.252-.143l-.461-.768a.299.299 0 0 1-.042-.151v-2.582Zm3.53-.768c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569Zm2.255-.294a.294.294 0 0 0-.294.294v2.157c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 19.01v-2.157a.294.294 0 0 0-.294-.294h-.98Zm-2.255 2.843c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569Zm2.255.294a.294.294 0 0 0-.294.294v.98c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 20.97v-.98a.294.294 0 0 0-.294-.294h-.98Z",
    style: {
      fill: "#fffaf0",
      fillRule: "evenodd",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.277 10.685a.5.5 0 0 0-.555 0l-2.597 1.731a.498.498 0 0 1-.277.084h-.849v1h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5v1h8v-1h-.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h.5v-1h-.849a.496.496 0 0 1-.277-.084l-2.597-1.731ZM34 14a.5.5 0 0 0-.5-.5H33a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-3Zm-3-.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h.5Z",
    style: {
      fill: "#fffaf0",
      fillRule: "evenodd"
    }
  }));
};
export default SvgGenericDark;